import { render, staticRenderFns } from "./StratificationView.vue?vue&type=template&id=5ec5e7ce"
import script from "./StratificationView.vue?vue&type=script&lang=js"
export * from "./StratificationView.vue?vue&type=script&lang=js"
import style0 from "./StratificationView.vue?vue&type=style&index=0&id=5ec5e7ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports